module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-1.c7b8a549.png";